<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" :class="items.class">
        <div :class="['user-guide-mask', 'user-guide-mask-' + items.type]" v-if="items.needMask">
          <template v-if="items.type === 'default'">
            <div v-for="highLight in items.highlightArea" :key="highLight.index">
              <div
              class="user-guide-top"
              :style="{
                height: (highLight.top + isMsgTop) + 'px',
                left: highLight.left + 'px',
                width: highLight.width + 'px',

              }"></div>
            <div
              class="user-guide-left"
              :style="{
                left: (highLight.index == 0 ? 0: (items.highlightArea[highLight.index - 1].left + items.highlightArea[highLight.index - 1].width )) + 'px',
                width:(highLight.index == 0 ? highLight.left: ( highLight.left - items.highlightArea[highLight.index - 1].left - items.highlightArea[highLight.index - 1].width )) + 'px',
              }"></div>
            <div v-if="highLight.index == (items.highlightArea.length - 1)"
              class="user-guide-right"
              :style="{
                left: highLight.left + highLight.width + 'px',
              }"></div>
            <div
              class="user-guide-bottom"
              :style="{
                top: highLight.top + isMsgTop + highLight.height + 'px',
                left: highLight.left + 'px',
                width: highLight.width + 'px',
              }"></div>
            </div>
            
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth) / 2 + 'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left: items.guideArea.left + 'px',
          }">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content">{{ items.content }}</div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="setUserGuideState" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/{{data.length}}</div>
            <div v-if="items.btnList.length" class="btnList">
              <div v-if="items.btnList.includes('video')" class="gj-pointer">参考教程<i class="el-icon-arrow-right"></i></div>
              <div v-if="items.btnList.includes('know')" @click="nextTask" class="gj-pointer knowBtn">我知道了</div>
              <div v-if="items.btnList.includes('next')" @click="nextStep" class="gj-pointer knowBtn">下一步</div>
              <div v-if="items.btnList.includes('complete')" @click="completeTask" class="gj-pointer completeBtn">完成任务</div>
            </div>
          </div>
          <!-- <div class="user-guide-point" v-if="items.lineType == 1">
            <div class="user-guider-line"></div>
          </div> -->
          <div v-if="(items.lineType == 1 || items.lineType == 2)"  class="user-guide-point-right">
            <div class="user-guider-line-right"></div>
          </div>
          <!-- <div v-if="items.lineType == 1"  class="user-guide-point-vertical">
            <div class="user-guider-line-vertical"></div>
          </div>   -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import {mapGetters} from "vuex";
import {userGuideMixin} from "@/minxins";
import NoviceGuide from '@/views/modules/home/novice-guide/novice-guide'

const clientWidth = document.body.clientWidth
export default {
  name: "new-user-guide",
  mixins: [userGuideMixin],
  props: {
    guideRef: {
      value: null
    }
  },
  data() {
    return {
      bootSteps: 0,
      startStep: 'storeAuthorize',
      data: [],
      taskName: '',
      taskList: {},
      isMsgTop: 0,

      taskItem: {},

      taskTypeCode: "COST_ACCOUNTING",
      taskChildCode: "COST_ACCOUNTING_001",

    }
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState',
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate : true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    }
  },
  created() {
    this.bootSteps = 1;
    this.taskItem = this.userGuideTaskItem

    this.taskName = this.startStep;
    const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical'
    const subtractHeight =  isNavHorizontal ? 0 : 44; 
    const addWidth =  isNavHorizontal ? 0 : 58; 
    this.subtractHeight = subtractHeight;
    this.addWidth = addWidth;
    this.taskList = {
        storeAuthorize: [
          {
            id: 1,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightArea: [{
              width: 430,
              height: 800,
              top: 225 - subtractHeight,
              left: 1300/2560*clientWidth ,
              index:0
            }],
            guideArea: {
              top: 300 - subtractHeight,
              left: 200 + addWidth,
            },
            guideWidth: 60,
            content: "您可以在列表中手动维护单个listing的采购成本和到库成本；也可以通过导入的方式批量维护,如果没有维护listing的成本信息，则系统无法为您生成准确的财务报表数据哦~",
            btnList: [],
            lineType:1,

          },
          {
            id: 2,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightArea: [{
              width: 430,
              height: 800,
              top: 225 - subtractHeight,
              left: 1300/2560*clientWidth,
              index:0
            }],
            guideArea: {
              top: 300 - subtractHeight,
              left: 200 + addWidth,
            },
            guideWidth: 60,
            content: "您维护好的成本数据可以在此处查看",
            btnList: ['next'],
            lineType:2,

          },
        ],
  
      }
    this.data = this.taskList[this.startStep];
    this.$nextTick(()=> {
      this.$forceUpdate()
    })
  },
  methods: {
    prevStep() {
      this.bootSteps--;
    },
    nextStep() {
      if (this.bootSteps == 2) {
        this.nextTask()
      }else {
        this.bootSteps++;
        let activeItem = this.data.find(item => item.id === this.bootSteps);
        if(activeItem && activeItem.type === 'menu') {
          this.$store.commit(SET_USER_GUIDE_MENU_PATH, activeItem.path);
        }
      }
    },
    async nextTask() { // 下个任务

      const taskItem = this.taskItem
      const {finishTaskList, nextTask} =  await this.getNextTask(this.taskTypeCode,this.taskChildCode)
      if (this.taskItem.taskStatus != 'COMPLETED' && finishTaskList){
                  this.completeTask();

      } else if (nextTask){// 有下一步
        if (this.isWaitTurnOn(nextTask.taskStatus)){// 任务未开启，需要 打开新手指引弹窗
          this.$message.warning( `${nextTask.taskChildName}任务未开启，请先开启任务~`)
          this.openNoviceGuide();
        }else {//下一步不属于当前组件，跳转新页面
          this.jumpToGuidePage(nextTask, () => {
            this.bootSteps = 0;
            this.$emit('finishGuide');
            this.$emit('closeModal');
          })
        }
      }else {
        this.cancel()
      }

        // this.$router.push({path: '/setting/argument?activeTab=financeCost'})
    },
    openNoviceGuide() {
      this.bootSteps = 2
      this.startStep = ''
      this.data = [];
      this.$gjCreate(NoviceGuide)
    },
    completeTask() {
      this.bootSteps = 0;
      this.data = [];
      this.$emit('closeModal');
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      this.$gjCreate(appUserGuideSucc,{
        global: true,
        props: {
          id: this.taskTypeCode
        }
      })
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2100;
    background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point-right {
    width: 680px;
    position: absolute;
    left: 400px;
    top: 10%;
    .user-guider-line-right {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
        margin-left:100%;
      }
    }
  }
  .user-guide-point-vertical {
    width: 30px;
    position: absolute;
    left: -120px;
    top: -80px;

    .user-guider-line-vertical {
      width: 2px;
      height: 128px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 0%;
        margin-top: -4px;
        margin-left:-3px;
      }
    }
    .user-guider-line-right {
      width: 100%;
      height: 2px;
      background: #4994FC;
    }
    .user-guider-line-right-point {
      border: 1px solid #4994FC;
        background-color: #4994FC;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-left:100%;
        margin-top: -5px;
    }
   
  }
  .user-guide-point {
    width: 120px;
    position: absolute;
    left: -120px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
</style>